import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A1F38] text-[#F8FAFC] py-16" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <img src="/pep-logo.png" alt="PEP Consulting AB" className="h-16 w-auto mb-4 brightness-0 invert" />
            <p className="font-['Manrope'] text-[#94A3B8] text-base leading-relaxed mb-6">
              Premium hardware and software solutions for modern environments. Creating elegant, minimalistic setups that enhance comfort, performance and user experience.
            </p>
            <div className="flex flex-col space-y-3">
              <a
                href="mailto:pontus.eriksson@pepconsulting.net"
                className="flex items-center space-x-2 text-[#94A3B8] hover:text-[#C5A05B] transition-colors duration-300"
                data-testid="footer-email-link"
              >
                <Mail size={18} />
                <span className="font-['Manrope'] text-sm">pontus.eriksson@pepconsulting.net</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Outfit'] text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/solutions"
                  className="font-['Manrope'] text-[#94A3B8] hover:text-[#C5A05B] transition-colors duration-300 text-sm"
                  data-testid="footer-link-solutions"
                >
                  Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/industries"
                  className="font-['Manrope'] text-[#94A3B8] hover:text-[#C5A05B] transition-colors duration-300 text-sm"
                  data-testid="footer-link-industries"
                >
                  Industries
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className="font-['Manrope'] text-[#94A3B8] hover:text-[#C5A05B] transition-colors duration-300 text-sm"
                  data-testid="footer-link-products"
                >
                  Products
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="font-['Manrope'] text-[#94A3B8] hover:text-[#C5A05B] transition-colors duration-300 text-sm"
                  data-testid="footer-link-about"
                >
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Outfit'] text-lg font-semibold mb-4">Get in Touch</h4>
            <Link
              to="/contact"
              className="inline-flex items-center px-6 py-3 rounded-full border border-[#C5A05B] text-[#C5A05B] font-['Manrope'] font-medium text-sm transition-all duration-300 hover:bg-[#C5A05B] hover:text-[#0A1F38]"
              data-testid="footer-contact-button"
            >
              Contact Us
            </Link>
          </div>
        </div>

        <div className="border-t border-[#334155] mt-12 pt-8 text-center">
          <p className="font-['Manrope'] text-[#94A3B8] text-sm">
            © {new Date().getFullYear()} PEP Consulting AB. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;